import React from "react";
import {
  Box,
  Flex,
  Text,
  Avatar,
  Stack,
  Button,
  HStack,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import StatusBadge from "../../../../../components/badges/StatusBadge";
import {
  newBorder,
  textPrimary,
  textSecondary,
  white,
} from "../../../../../utils/colors";
import dayjs from "dayjs";
import StatusBadgeAlt from "../../../../../components/badges/StatusBadgeAlt";
import StatusBadgeNew from "../../../../../components/badges/StatusBadgeNew";

const EmployeeCardMobile = ({ key, data, onClick, onDelete }) => {
  const navigate = useNavigate();
  const { slug } = useParams();

  const fullName = `${data.lastName} ${data.firstName}`;
  const age = data.birthDate
    ? dayjs().diff(dayjs(data.birthDate), "year")
    : null;

  const birthDayYear = data.birthDate
    ? dayjs(data.birthDate).format("YYYY")
    : "-";

  return (
    <Box
      borderRadius="1rem"
      bg={white}
      onClick={() => onClick(data._id)}
      //   shadow="md"
      //   mb="1.25rem"
      w="100%"
      border={`1px solid ${newBorder}`}
      p="1rem"
    >
      <Flex gap={4} align="center">
        <Avatar name={fullName} src={data.image} w="2.5rem" h="2.5rem" />
        <Stack spacing={0}>
          <Text fontSize="1.125rem" fontWeight="600" isTruncated>
            {fullName}
          </Text>
          <Text fontSize="sm" color={textSecondary}>
            {/* {patientID}  */}
            {/*             
            {age ? `${age} yrs` : "-"} {phone || "-"} */}
            {birthDayYear}
          </Text>
        </Stack>
      </Flex>

      <Flex mt={4} justify="space-between" align="center">
        <Flex align="center" gap={2}>
          <Text fontSize="sm" fontWeight="600" color={textPrimary}>
            {data.employeeID || "N/A"}
          </Text>
        </Flex>

        <StatusBadgeNew
          status={data.status}
          options="user"
          p="0.25rem 0.5rem"
          fontSize="xs"
        />
        {/* <HStack spacing={3}>
          <Button
            size="sm"
            variant="ghost"
            onClick={() => navigate(`/${slug}/patients/${_id}`)}
          >
            View
          </Button>
          <Button size="sm" variant="ghost" color="red.500" onClick={onDelete}>
            Delete
          </Button>
        </HStack> */}
      </Flex>
    </Box>
  );
};

export default EmployeeCardMobile;
